<template>
    <div class="modal fade pcc-modal" :id="modalId" tabindex="-1" role="dialog"
        aria-labelledby="formularioPccModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div class="modal-content pcc-modal-content">

                <!-- HEADER -->
                <div class="modal-header pcc-modal-header">
                    <div class="pcc-header-content">

                        <div class="pcc-header-icon">
                            <i class="fas fa-clipboard-check"></i>
                        </div>

                        <div>
                            <h5 class="modal-title" id="formularioPccModalLabel">
                                Formulario PCC
                            </h5>

                            <div class="pcc-guia-number">
                                Guía(s) {{ formulario_pcc.numero_guia }}
                            </div>

                            <div v-if="firmantes.length" class="pcc-firmantes">
                                <span v-for="(f, i) in firmantes" :key="f.label">
                                    <template v-if="i > 0">
                                        <span class="pcc-firmante-separator">•</span>
                                    </template>

                                    <i class="fas fa-check-circle"></i>
                                    {{ f.label }}: {{ f.nombre }}
                                </span>
                            </div>
                        </div>

                    </div>

                    <div class="pcc-header-actions">
                        <button v-if="formulario_pcc" @click="guardarCambios" class="btn-guardar" :disabled="guardando">
                            <i :class="guardando
                                ? 'fas fa-spinner fa-spin'
                                : 'fas fa-save'">
                            </i>

                            {{ guardando ? 'Guardando...' : 'Guardar' }}
                        </button>

                        <button @click="generarPdf" class="btn-pdf" :disabled="!formulario_pcc.id">
                            <i class="fas fa-file-pdf"></i>
                            Generar PDF
                        </button>

                        <button type="button" class="pcc-close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>

                    </div>
                </div>


                <!-- BODY -->
                <div class="modal-body pcc-modal-body" v-if="formulario_pcc">

                    <!-- INFORMACIÓN GENERAL -->
                    <div class="pcc-info-card">

                        <div class="pcc-info-header">

                            <div class="pcc-info-title">
                                <div class="pcc-section-icon">
                                    <i class="fas fa-info-circle"></i>
                                </div>

                                <div>
                                    <h5 class="text-white">Información del formulario</h5>
                                    <span>
                                        Datos generales asociados a la guía
                                    </span>
                                </div>
                            </div>

                            <span class="pcc-status">
                                <i class="fas fa-file-alt"></i>
                                PCC
                            </span>

                        </div>

                        <div class="pcc-info-body">

                            <div class="pcc-info-item">
                                <div class="pcc-icon">
                                    <i class="fas fa-calendar-alt"></i>
                                </div>

                                <div>
                                    <small>Fecha</small>
                                    <strong>
                                        {{ (formulario_pcc.fecha || '-') | fecha }}
                                    </strong>
                                </div>
                            </div>

                            <div class="pcc-info-item">
                                <div class="pcc-icon">
                                    <i class="fas fa-file-invoice"></i>
                                </div>

                                <div>
                                    <small>Folio</small>
                                    <strong>
                                        {{ formulario_pcc.folio || '-' }}
                                    </strong>
                                </div>
                            </div>

                            <div class="pcc-info-item">
                                <div class="pcc-icon">
                                    <i class="fas fa-truck"></i>
                                </div>

                                <div>
                                    <small>Patente</small>
                                    <strong>
                                        {{ formulario_pcc.patente || '-' }}
                                    </strong>
                                </div>
                            </div>

                            <div class="pcc-info-item">
                                <div class="pcc-icon">
                                    <i class="fas fa-boxes"></i>
                                </div>

                                <div>
                                    <small>Cantidad de Bins</small>
                                    <strong>
                                        {{ formulario_pcc.cantidad_bins || 0 }}
                                    </strong>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="limite-critico-info">
                        <div class="limite-critico-titulo">
                            LIMITE CRITICO (LC)
                        </div>

                        <div class="limite-critico-subtitulo">
                            NO SE ACEPTA SI:
                        </div>

                        <div class="limite-critico-lista">
                            <div>1.- NO PRESENTA DOCUMENTACION REQUERIDA</div>
                            <div>2.- ERROR EN LA DESIGNACION DE CALIFICACION MP CON RESTRICCION</div>
                            <div>3.- MMPP SUPERA LAS 24 HRS. DE TRASLADO.</div>
                            <div>4.- MMPP SUPERA LAS 72 HRS. DE TRASLADO.</div>
                        </div>
                    </div>

                    <fieldset :disabled="formularioBloqueado" style="border: none; padding: 0; margin: 0;">
                        <!-- SUBPRODUCTOS -->
                        <div class="pcc-section" v-if="Number(mp_tipos_id) === 1">

                            <div class="pcc-section-header">
                                <div class="pcc-section-header-left">


                                    <div>
                                        <h4>Subproductos</h4>

                                    </div>
                                </div>

                                <i class="fas fa-fish pcc-section-header-icon"></i>
                            </div>


                            <!-- SUBPRODUCTOS -->
                            <div class="pcc-question-card">

                                <div class="pcc-question-title">
                                    <span>Subproductos</span>

                                </div>

                                <div class="pcc-options">

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="subproducto" value="CON PAC"
                                            v-model="formulario_pcc.subproducto">

                                        <span class="pcc-radio-custom"></span>

                                        <span>CON PAC</span>
                                    </label>

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="subproducto" value="SIN PAC"
                                            v-model="formulario_pcc.subproducto">

                                        <span class="pcc-radio-custom"></span>

                                        <span>SIN PAC</span>
                                    </label>

                                </div>
                            </div>


                            <!-- LISTADO MAESTRO -->
                            <div class="pcc-question-card">

                                <div class="pcc-question-title">
                                    <span>Listado Maestro</span>

                                </div>

                                <div class="pcc-options">

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="subproducto_listado_maestro" value="SI"
                                            v-model="formulario_pcc.subproducto_listado_maestro">

                                        <span class="pcc-radio-custom"></span>

                                        <span>SI</span>
                                    </label>

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="subproducto_listado_maestro" value="NO"
                                            v-model="formulario_pcc.subproducto_listado_maestro">

                                        <span class="pcc-radio-custom"></span>

                                        <span>NO</span>
                                    </label>

                                </div>
                            </div>


                            <!-- RESTRICCIÓN -->
                            <div class="pcc-question-card">

                                <div class="pcc-question-title">
                                    <span>Restricción de mercado según DJ</span>

                                </div>

                                <div class="pcc-options">

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="subproducto_rest_mercado_dj" value="CON RESTRICCIÓN"
                                            v-model="formulario_pcc.subproducto_rest_mercado_dj">

                                        <span class="pcc-radio-custom"></span>

                                        <span>CON RESTRICCIÓN</span>
                                    </label>

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="subproducto_rest_mercado_dj" value="SIN RESTRICCIÓN"
                                            v-model="formulario_pcc.subproducto_rest_mercado_dj">

                                        <span class="pcc-radio-custom"></span>

                                        <span>SIN RESTRICCIÓN</span>
                                    </label>

                                </div>
                            </div>


                            <!-- GUIA DESPACHO -->
                            <div class="pcc-question-card">

                                <div class="pcc-question-title">
                                    <span>Guía de Despacho</span>
                                </div>

                                <div class="pcc-options">

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="subproducto_guia_despacho" value="CUMPLE"
                                            v-model="formulario_pcc.subproducto_guia_despacho">

                                        <span class="pcc-radio-custom"></span>

                                        <span>CUMPLE</span>
                                    </label>

                                    <label class="pcc-radio-option pcc-option-danger">
                                        <input type="radio" name="subproducto_guia_despacho" value="NO CUMPLE"
                                            v-model="formulario_pcc.subproducto_guia_despacho">

                                        <span class="pcc-radio-custom"></span>

                                        <span>NO CUMPLE</span>
                                    </label>

                                </div>

                                <div v-show="formulario_pcc.subproducto_guia_despacho === 'NO CUMPLE'"
                                    class="pcc-corrective">
                                    <div class="pcc-corrective-header">
                                        <i class="fas fa-exclamation-triangle"></i>
                                        Acción correctiva
                                    </div>

                                    <v-select class="" v-model="formulario_pcc.subproducto_guia_despacho_accion_correctiva"
                                  :closeOnSelect="false" :options="accionesCorrectivas"
                                  label="Acción Correctiva" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>

                                </div>

                            </div>


                            <!-- DECLARACIÓN JURADA -->
                            <div class="pcc-question-card">

                                <div class="pcc-question-title">
                                    <span>Declaración Jurada</span>
                                </div>

                                <div class="pcc-options">

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="subproducto_declaracion_jurada" value="CUMPLE"
                                            v-model="formulario_pcc.subproducto_declaracion_jurada">

                                        <span class="pcc-radio-custom"></span>

                                        <span>CUMPLE</span>
                                    </label>

                                    <label class="pcc-radio-option pcc-option-danger">
                                        <input type="radio" name="subproducto_declaracion_jurada" value="NO CUMPLE"
                                            v-model="formulario_pcc.subproducto_declaracion_jurada">

                                        <span class="pcc-radio-custom"></span>

                                        <span>NO CUMPLE</span>
                                    </label>

                                </div>

                                <div v-show="formulario_pcc.subproducto_declaracion_jurada === 'NO CUMPLE'"
                                    class="pcc-corrective">
                                    <div class="pcc-corrective-header">
                                        <i class="fas fa-exclamation-triangle"></i>
                                        Acción correctiva
                                    </div>

                                    <v-select class="" v-model="formulario_pcc.subproducto_declaracion_jurada_accion_correctiva"
                                  :closeOnSelect="false" :options="accionesCorrectivas"
                                  label="Acción Correctiva" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>

                                </div>

                            </div>


                            <!-- UE -->
                            <div class="pcc-question-card">

                                <div class="pcc-question-title">
                                    <span>
                                        Cumple UE
                                    </span>

                                    <small>
                                        Según Restricción DJ y/o Tiempo Traslado &lt; 24 Hrs
                                    </small>
                                </div>

                                <div class="pcc-options">

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="subproducto_cumple_restriccion_horas_traslado"
                                            value="SI"
                                            v-model="formulario_pcc.subproducto_cumple_restriccion_horas_traslado">

                                        <span class="pcc-radio-custom"></span>

                                        <span>SI</span>
                                    </label>

                                    <label class="pcc-radio-option pcc-option-danger">
                                        <input type="radio" name="subproducto_cumple_restriccion_horas_traslado"
                                            value="NO"
                                            v-model="formulario_pcc.subproducto_cumple_restriccion_horas_traslado">

                                        <span class="pcc-radio-custom"></span>

                                        <span>NO</span>
                                    </label>

                                </div>

                            </div>

                        </div>


                        <!-- MORTALIDAD -->
                        <div class="pcc-section" v-if="
                            Number(mp_tipos_id) === 2 ||
                            Number(mp_tipos_id) === 3
                        ">

                            <div class="pcc-section-header pcc-section-header-mortality">

                                <div class="pcc-section-header-left">



                                    <div>
                                        <h4>Mortalidad</h4>

                                    </div>

                                </div>

                                <i class="fas fa-fish pcc-section-header-icon"></i>

                            </div>


                            <!-- GUIA DESPACHO -->
                            <div class="pcc-question-card">

                                <div class="pcc-question-title">
                                    <span>Guía de Despacho</span>
                                </div>

                                <div class="pcc-options">

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="mortalidad_guia_despacho" value="CUMPLE"
                                            v-model="formulario_pcc.mortalidad_guia_despacho">

                                        <span class="pcc-radio-custom"></span>

                                        <span>CUMPLE</span>
                                    </label>

                                    <label class="pcc-radio-option pcc-option-danger">
                                        <input type="radio" name="mortalidad_guia_despacho" value="NO CUMPLE"
                                            v-model="formulario_pcc.mortalidad_guia_despacho">

                                        <span class="pcc-radio-custom"></span>

                                        <span>NO CUMPLE</span>
                                    </label>

                                </div>

                                <div v-show="formulario_pcc.mortalidad_guia_despacho === 'NO CUMPLE'"
                                    class="pcc-corrective">
                                    <div class="pcc-corrective-header">
                                        <i class="fas fa-exclamation-triangle"></i>
                                        Acción correctiva
                                    </div>

                                    <v-select class="" v-model="formulario_pcc.mortalidad_guia_despacho_accion_correctiva"
                                  :closeOnSelect="false" :options="accionesCorrectivas"
                                  label="Acción Correctiva" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>
                                </div>

                            </div>


                            <!-- DECLARACIÓN JURADA -->
                            <div class="pcc-question-card">

                                <div class="pcc-question-title">
                                    <span>Declaración Jurada</span>
                                </div>

                                <div class="pcc-options">

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="mortalidad_declaracion_jurada" value="CUMPLE"
                                            v-model="formulario_pcc.mortalidad_declaracion_jurada">

                                        <span class="pcc-radio-custom"></span>

                                        <span>CUMPLE</span>
                                    </label>

                                    <label class="pcc-radio-option pcc-option-danger">
                                        <input type="radio" name="mortalidad_declaracion_jurada" value="NO CUMPLE"
                                            v-model="formulario_pcc.mortalidad_declaracion_jurada">

                                        <span class="pcc-radio-custom"></span>

                                        <span>NO CUMPLE</span>
                                    </label>

                                </div>

                                <div v-show="formulario_pcc.mortalidad_declaracion_jurada === 'NO CUMPLE'"
                                    class="pcc-corrective">
                                    <div class="pcc-corrective-header">
                                        <i class="fas fa-exclamation-triangle"></i>
                                        Acción correctiva
                                    </div>

                                    <v-select class="" v-model="formulario_pcc.mortalidad_declaracion_jurada_accion_correctiva"
                                  :closeOnSelect="false" :options="accionesCorrectivas"
                                  label="Acción Correctiva" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>

                                    
                                </div>

                            </div>


                            <!-- CAM -->
                            <div class="pcc-question-card">

                                <div class="pcc-question-title">
                                    <span>
                                        CAM
                                    </span>

                                    <small>
                                        Certificado de Autorización de Movimiento
                                    </small>
                                </div>

                                <div class="pcc-options">

                                    <label class="pcc-radio-option">
                                        <input type="radio" name="mortalidad_cam" value="CUMPLE"
                                            v-model="formulario_pcc.mortalidad_cam">

                                        <span class="pcc-radio-custom"></span>

                                        <span>CUMPLE</span>
                                    </label>

                                    <label class="pcc-radio-option pcc-option-danger">
                                        <input type="radio" name="mortalidad_cam" value="NO CUMPLE"
                                            v-model="formulario_pcc.mortalidad_cam">

                                        <span class="pcc-radio-custom"></span>

                                        <span>NO CUMPLE</span>
                                    </label>

                                </div>

                                <div v-show="formulario_pcc.mortalidad_cam === 'NO CUMPLE'" class="pcc-corrective">
                                    <div class="pcc-corrective-header">
                                        <i class="fas fa-exclamation-triangle"></i>
                                        Acción correctiva
                                    </div>

                                    <v-select class="" v-model="formulario_pcc.mortalidad_cam_accion_correctiva"
                                  :closeOnSelect="false" :options="accionesCorrectivas"
                                  label="Acción Correctiva" multiple>
                                  <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                      No se Encontraron Resultados Para
                                      <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                                  </template>
                                </v-select>

                                </div>

                            </div>

                        </div>


                        <!-- OBSERVACIONES -->
                        <div class="pcc-observaciones-card">

                            <div class="pcc-observaciones-header">

                                <div class="pcc-section-icon">
                                    <i class="fas fa-comment-alt"></i>
                                </div>

                                <div>
                                    <h5>Observaciones</h5>
                                    <span>
                                        Información adicional del formulario
                                    </span>
                                </div>

                            </div>

                            <textarea class="form-control pcc-observaciones-input" rows="4" name="" id=""
                                placeholder="Ingrese las observaciones..."
                                v-model="formulario_pcc.observaciones"></textarea>

                        </div>
                    </fieldset>

                    <!-- FIRMA -->
                    <div class="pcc-firma-card" v-if="rolFirma && formulario_pcc.id">

                        <div class="pcc-firma-info">

                            <div class="pcc-firma-icon">
                                <i :class="yaFirmado
                                    ? 'fas fa-check-circle'
                                    : 'fas fa-signature'"></i>
                            </div>

                            <div>

                                <h5>
                                    {{ yaFirmado
                                        ? 'Formulario firmado'
                                        : 'Firma del formulario'
                                    }}
                                </h5>

                                <span v-if="yaFirmado">
                                    El formulario fue firmado como
                                    <strong>{{ rolFirma.label }}</strong>
                                </span>

                                <span v-else>
                                    Confirme la firma correspondiente a su cargo:
                                    <strong>{{ rolFirma.label }}</strong>
                                </span>

                            </div>

                        </div>

                        <button v-if="!yaFirmado" type="button" class="btn-confirmar-firma" :disabled="firmando"
                            @click="confirmarFirma">
                            <i :class="firmando
                                ? 'fas fa-spinner fa-spin'
                                : 'fas fa-signature'"></i>

                            {{ firmando
                                ? 'Firmando...'
                                : `Confirmar Firma como ${rolFirma.label}`
                            }}
                        </button>

                        <span v-else class="pcc-firmado-badge">
                            <i class="fas fa-check-circle"></i>
                            Firmado como {{ rolFirma.label }}
                        </span>

                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2';

export default {
    name: 'FormularioPccModal',
    props: {
        formulario_pcc: { type: Object, required: true },
        modalId: { type: String, required: true },
        modo: { type: String, default: 'standalone' }, // 'ticket' | 'standalone'
        mp_tipos_id: {
            type: [Number, String],
            required: true
        }
    },
    data: () => ({
        firmando: false,
        guardando: false,
        accionesCorrectivas: [1,2,3,4]
    }),
    watch: {
        // Al volver a "CUMPLE" el textarea de acción correctiva se oculta con v-show, pero el
        // texto sigue viviendo en el modelo si no se limpia acá: quedaba guardándose "fantasma"
        // y activaba de forma incorrecta la firma obligatoria de Jefe Trazabilidad.
        'formulario_pcc.subproducto_guia_despacho'(valor) {
            if (valor === 'CUMPLE' && this.formulario_pcc) {
                this.formulario_pcc.subproducto_guia_despacho_accion_correctiva = null;
            }
        },
        'formulario_pcc.subproducto_declaracion_jurada'(valor) {
            if (valor === 'CUMPLE' && this.formulario_pcc) {
                this.formulario_pcc.subproducto_declaracion_jurada_accion_correctiva = null;
            }
        },
        'formulario_pcc.mortalidad_guia_despacho'(valor) {
            if (valor === 'CUMPLE' && this.formulario_pcc) {
                this.formulario_pcc.mortalidad_guia_despacho_accion_correctiva = null;
            }
        },
        'formulario_pcc.mortalidad_declaracion_jurada'(valor) {
            if (valor === 'CUMPLE' && this.formulario_pcc) {
                this.formulario_pcc.mortalidad_declaracion_jurada_accion_correctiva = null;
            }
        },
        'formulario_pcc.mortalidad_cam'(valor) {
            if (valor === 'CUMPLE' && this.formulario_pcc) {
                this.formulario_pcc.mortalidad_cam_accion_correctiva = null;
            }
        },
    },
    computed: {
        ...mapState(['api', 'cabeceras_json', 'usuario']),
        formularioBloqueado() {
            //bloqueo si es que el romanero ya firmo
            return this.formulario_pcc.check_romanero == 1 &&
                this.usuario.cargo_id == 1;
        },
        firmantes() {
            const f = this.formulario_pcc;
            if (!f) return [];
            const lista = [];
            if (f.check_romanero && f.romanero_nombre) lista.push({ label: 'Romanero', nombre: f.romanero_nombre });
            if (f.check_jefe_pac && f.jefe_pac_nombre) lista.push({ label: 'Jefe PAC', nombre: f.jefe_pac_nombre });
            if (f.check_jefe_trazabilidad && f.jefe_trazabilidad_nombre) {
                lista.push({ label: 'Jefe Trazabilidad', nombre: f.jefe_trazabilidad_nombre });
            }
            return lista;
        },
        tieneAccionCorrectiva() {

            const f = this.formulario_pcc;

            if (!f) return false;

            return [
                f.subproducto_guia_despacho,
                f.subproducto_declaracion_jurada,
                f.mortalidad_guia_despacho,
                f.mortalidad_declaracion_jurada,
                f.mortalidad_cam,
            ].some((v) => String(v || '').trim().toUpperCase() === 'NO CUMPLE');

        },
        rolFirma() {
            const f = this.formulario_pcc;
            const cargoId = this.usuario.cargo_id;

            if (cargoId === 1) {
                return { campoCheck: 'check_romanero', campoId: 'romanero_id', label: 'Romanero' };
            }

            if (cargoId === 3 || cargoId === 4) {
                // Jefe PAC/ Jefe Calidad: solo si el Romanero ya firmó.
                if (!f && !f.check_romanero && this.tieneAccionCorrectiva) return null;
                let label = `${cargoId === 3? 'Jefe PAC':'Jefe Calidad'}`
                return { campoCheck: 'check_jefe_pac', campoId: 'jefe_pac_id', label: label };
            }

            if (cargoId === 2) {
                // Jefe Trazabilidad: solo si Romanero firmo y existe
                // al menos una acción correctiva.
                if (!f && !f.check_romanero && !this.tieneAccionCorrectiva) return null;
                return { campoCheck: 'check_jefe_trazabilidad', campoId: 'jefe_trazabilidad_id', label: 'Jefe Trazabilidad' };
            }

            return null;
        },
        yaFirmado() {
            if (!this.rolFirma || !this.formulario_pcc) return false;
            return !!this.formulario_pcc[this.rolFirma.campoCheck];
        },
    },
    methods: {
        validarFormulario() {

            const formulario = this.formulario_pcc;

            if (!formulario) {
                return false;
            }

            const errores = [];

            /*
             * =====================================================
             * TIPO 1 - SUBPRODUCTOS
             * =====================================================
             */
            if (Number(this.mp_tipos_id) === 1) {

                if (!formulario.subproducto) {
                    errores.push('Subproductos');
                }

                if (!formulario.subproducto_listado_maestro) {
                    errores.push('Listado Maestro');
                }

                if (!formulario.subproducto_rest_mercado_dj) {
                    errores.push('Restricción de mercado según DJ');
                }

                if (!formulario.subproducto_guia_despacho) {
                    errores.push('Guía de Despacho');
                }

                if (!formulario.subproducto_declaracion_jurada) {
                    errores.push('Declaración Jurada');
                }

                if (!formulario.subproducto_cumple_restriccion_horas_traslado) {
                    errores.push('Cumple UE');
                }


                // Acción correctiva obligatoria si NO CUMPLE

                if (
                    formulario.subproducto_guia_despacho === 'NO CUMPLE' &&
                    !formulario.subproducto_guia_despacho_accion_correctiva?.length
                ) {
                    errores.push(
                        'Acción correctiva de Guía de Despacho'
                    );
                }

                if (
                    formulario.subproducto_declaracion_jurada === 'NO CUMPLE' &&
                    !formulario.subproducto_declaracion_jurada_accion_correctiva?.length
                ) {
                    errores.push(
                        'Acción correctiva de Declaración Jurada'
                    );
                }
            }


            /*
             * =====================================================
             * TIPO 2 / 3 - MORTALIDAD
             * =====================================================
             */
            if (
                Number(this.mp_tipos_id) === 2 ||
                Number(this.mp_tipos_id) === 3
            ) {

                if (!formulario.mortalidad_guia_despacho) {
                    errores.push('Guía de Despacho');
                }

                if (!formulario.mortalidad_declaracion_jurada) {
                    errores.push('Declaración Jurada');
                }

                if (!formulario.mortalidad_cam) {
                    errores.push('CAM');
                }


                // Acción correctiva obligatoria si NO CUMPLE

                if (
                    formulario.mortalidad_guia_despacho === 'NO CUMPLE' &&
                    !formulario.mortalidad_guia_despacho_accion_correctiva?.length
                ) {
                    errores.push(
                        'Acción correctiva de Guía de Despacho'
                    );
                }

                if (
                    formulario.mortalidad_declaracion_jurada === 'NO CUMPLE' &&
                    !formulario.mortalidad_declaracion_jurada_accion_correctiva?.length
                ) {
                    errores.push(
                        'Acción correctiva de Declaración Jurada'
                    );
                }

                if (
                    formulario.mortalidad_cam === 'NO CUMPLE' &&
                    !formulario.mortalidad_cam_accion_correctiva?.length
                ) {
                    errores.push(
                        'Acción correctiva de CAM'
                    );
                }
            }


            /*
             * =====================================================
             * MOSTRAR ERRORES
             * =====================================================
             */

            if (errores.length > 0) {

                Swal.fire({
                    icon: 'warning',
                    title: 'Formulario incompleto',
                    html: `
                <div style="text-align:left">
                    <p>
                        Debes completar los siguientes campos:
                    </p>

                    <ul>
                        ${errores
                            .map(error => `<li>${error}</li>`)
                            .join('')
                        }
                    </ul>
                </div>
            `,
                    confirmButtonText: 'Entendido'
                });

                return false;
            }

            return true;
        },
        async confirmarFirma() {

            /*
             * Primero validamos el formulario
             */
            if (!this.validarFormulario()) {
                return;
            }


            /*
             * Verificamos que exista un cargo habilitado para firmar
             */
            if (!this.rolFirma) {
                return;
            }


            /*
             * Evitar doble click
             */
            if (this.firmando) {
                return;
            }


            /*
             * Confirmación
             */
            const resultado = await Swal.fire({

                icon: 'warning',

                title: '¿Confirmar firma?',

                html: `
            <p>
                Está a punto de firmar el
                <strong>Formulario PCC</strong>.
            </p>

            <div style="
                margin-top:15px;
                padding:12px;
                background:#f5f7fa;
                border-radius:8px;
            ">
                <strong>Cargo:</strong>
                ${this.rolFirma.label}
            </div>

            <p style="
                margin-top:15px;
                color:#6b7280;
                font-size:13px;
            ">
                Una vez registrada la firma,
                esta quedará asociada a su usuario.
            </p>
        `,

                showCancelButton: true,

                confirmButtonText: `
            <i class="fas fa-signature"></i>
            Sí, firmar
        `,

                cancelButtonText: 'Cancelar',

                confirmButtonColor: '#198754',

                cancelButtonColor: '#6c757d',

                reverseButtons: true
            });


            /*
             * Usuario canceló
             */
            if (!resultado.isConfirmed) {
                return;
            }


            /*
             * Obtenemos nuevamente el formulario
             */
            const formulario = this.formulario_pcc;


            /*
             * Si todavía no existe ID
             */
            if (!formulario || !formulario.id) {

                Swal.fire({
                    icon: 'error',
                    title: 'No se puede firmar',
                    text: 'El formulario todavía no ha sido guardado.'
                });

                return;
            }


            this.firmando = true;


            try {

                const res = await this.axios.post(
                    `${this.api}/formulario_pcc/${formulario.id}/firmar`,
                    {},
                    this.cabeceras_json
                );


                if (res.data.codigo === 200) {

                    /*
                     * Actualizar información recibida
                     * desde el backend
                     */
                    Object.assign(
                        this.formulario_pcc,
                        res.data.data
                    );


                    /*
                     * Informar al componente padre
                     */
                    this.$emit(
                        'actualizado',
                        this.formulario_pcc
                    );


                    /*
                     * Confirmación visual
                     */
                    await Swal.fire({
                        icon: 'success',
                        title: 'Firma registrada',
                        text: `El formulario fue firmado como ${this.rolFirma.label}.`,
                        timer: 1800,
                        showConfirmButton: false
                    });


                } else {

                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: res.data.mensaje ||
                            'No se pudo registrar la firma.'
                    });
                }


            } catch (error) {

                console.error(error);

                let mensaje =
                    'No se pudo registrar la firma.';

                if (
                    error.response &&
                    error.response.data &&
                    error.response.data.mensaje
                ) {
                    mensaje =
                        error.response.data.mensaje;
                }


                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: mensaje
                });


            } finally {

                this.firmando = false;
            }
        },
        async guardarCambios() {
            if (!this.validarFormulario()) {
                return;
            }
            const formulario = this.formulario_pcc;
            //if (!formulario || !formulario.id) return;

            this.guardando = true;
            try {
                const res = await this.axios.post(
                    `${this.api}/formulario_pcc`,
                    formulario,
                    this.cabeceras_json
                );
                if (res.data.codigo === 200) {
                    Object.assign(this.formulario_pcc, res.data.data);
                    this.$emit('actualizado', this.formulario_pcc);
                    Swal.fire({ icon: 'success', title: 'Guardado', text: 'Formulario actualizado.', timer: 1500, showConfirmButton: false });
                } else {
                    Swal.fire({ icon: 'error', title: 'Error', text: res.data.mensaje || 'No se pudo guardar el formulario.' });
                }
            } catch (error) {
                console.error(error);
                let mensaje = 'No se pudo guardar el formulario.';
                if (error.response && error.response.data && error.response.data.mensaje) {
                    mensaje = error.response.data.mensaje;
                }
                Swal.fire({ icon: 'error', title: 'Error', text: mensaje });
            } finally {
                this.guardando = false;
            }
        },
        generarPdf() {
            const url = `${this.api}/formulario/pcc/${this.formulario_pcc.id}`;

            const ventana = window.open(url, '_blank');

            if (!ventana) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Ventana bloqueada',
                    text: 'El navegador bloqueó la ventana del PDF. Permite las ventanas emergentes para este sitio e inténtalo de nuevo.',
                });
            }
        }
    },
};
</script>

<style scoped>
.pcc-modal-content {
    border: none;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(13, 31, 69, 0.25);
}


/* =========================================================
   HEADER
   ========================================================= */

.pcc-modal-header {
    padding: 18px 24px;
    border: none;
    background: #0d1f45;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.pcc-header-content {
    display: flex;
    align-items: center;
    gap: 14px;
}

.pcc-header-icon {
    width: 46px;
    height: 46px;
    border-radius: 11px;
    background: rgba(255, 255, 255, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 21px;
    color: #8db5f2;
}

.pcc-modal-header .modal-title {
    font-size: 20px;
    font-weight: 700;
    margin: 0;
    color: #fff;
}

.pcc-guia-number {
    margin-top: 2px;
    color: #c4d9f5;
    font-size: 13px;
    font-weight: 500;
}

.pcc-firmantes {
    margin-top: 6px;
    font-size: 11px;
    color: #c4d9f5;
}

.pcc-firmantes i {
    color: #50d890;
    margin-right: 3px;
}

.pcc-firmante-separator {
    margin: 0 6px;
    color: #6d89b8;
}

.pcc-header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}


/* =========================================================
   BOTONES
   ========================================================= */

.btn-guardar,
.btn-pdf {
    border: none;
    padding: 9px 15px;
    border-radius: 7px;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-guardar {
    background: #337fd9;
}

.btn-guardar:hover {
    background: #286bc0;
    transform: translateY(-1px);
}

.btn-pdf {
    background: #dc3545;
}

.btn-pdf:hover {
    background: #c82333;
    transform: translateY(-1px);
}

.btn-guardar:disabled,
.btn-pdf:disabled {
    opacity: .45;
    cursor: not-allowed;
    transform: none;
}

.btn-guardar i,
.btn-pdf i {
    margin-right: 5px;
}

.pcc-close {
    border: none;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    width: 36px;
    height: 36px;
    border-radius: 7px;
    font-size: 25px;
    line-height: 1;
    margin-left: 4px;
    cursor: pointer;
    transition: all .2s ease;
}

.pcc-close:hover {
    background: rgba(255, 255, 255, 0.2);
}


/* =========================================================
   BODY
   ========================================================= */

.pcc-modal-body {
    background: #f5f7fb;
    padding: 22px;
}


/* =========================================================
   INFORMACIÓN GENERAL
   ========================================================= */

.pcc-info-card {
    background: #fff;
    border: 1px solid #e4e9f1;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 22px;
    box-shadow: 0 3px 12px rgba(20, 42, 75, .05);
}

.pcc-info-header {
    min-height: 70px;
    padding: 14px 18px;
    background: #0d1f45;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.pcc-info-title {
    display: flex;
    align-items: center;
    gap: 12px;
}

.pcc-info-title h5 {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
}

.pcc-info-title span {
    display: block;
    color: #c4d9f5;
    font-size: 11px;
    margin-top: 2px;
}

.pcc-section-icon {
    width: 38px;
    height: 38px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e8f1fc;
    color: #337fd9;
    font-size: 17px;
}

.pcc-info-header .pcc-section-icon {
    background: rgba(255, 255, 255, .1);
    color: #8db5f2;
}

.pcc-status {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 6px 11px;
    background: #337fd9;
    color: #fff;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
}

.pcc-info-body {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    padding: 16px;
}

.pcc-info-item {
    display: flex;
    align-items: center;
    gap: 11px;
    min-height: 66px;
    padding: 11px 13px;
    background: #f7f9fc;
    border: 1px solid #edf0f5;
    border-radius: 9px;
}

.pcc-icon {
    width: 38px;
    height: 38px;
    min-width: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: #e8f1fc;
    color: #337fd9;
    font-size: 15px;
}

.pcc-info-item small {
    display: block;
    color: #7c8799;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: .4px;
    margin-bottom: 3px;
}

.pcc-info-item strong {
    display: block;
    color: #1e293b;
    font-size: 14px;
    font-weight: 700;
}


/* =========================================================
   SECCIONES
   ========================================================= */

.pcc-section {
    margin-bottom: 22px;
}

.pcc-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 17px;
    background: #0d1f45;
    color: white;
    border-radius: 11px 11px 0 0;
}

.pcc-section-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.pcc-section-number {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 9px;
    background: rgba(255, 255, 255, .11);
    color: #8db5f2;
    font-size: 12px;
    font-weight: 800;
}

.pcc-section-header h4 {
    margin: 0;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
}

.pcc-section-header span {
    display: block;
    color: #b8c9e5;
    font-size: 11px;
    margin-top: 2px;
}

.pcc-section-header-icon {
    color: #8db5f2;
    font-size: 21px;
    margin-right: 4px;
}

.pcc-section-header-mortality {
    background: #182d52;
}


/* =========================================================
   PREGUNTAS
   ========================================================= */

.pcc-question-card {
    background: #fff;
    border: 1px solid #e3e8ef;
    border-top: none;
    padding: 15px 17px;
    display: flex;
    align-items: center;
    gap: 20px;
    min-height: 72px;
    transition: background .2s ease;
}

.pcc-question-card:last-child {
    border-radius: 0 0 11px 11px;
}

.pcc-question-card:hover {
    background: #fbfcfe;
}

.pcc-question-title {
    width: 42%;
    min-width: 300px;
}

.pcc-question-title span {
    display: block;
    color: #24334d;
    font-size: 13px;
    font-weight: 700;
}

.pcc-question-title small {
    display: block;
    color: #8a95a6;
    font-size: 10px;
    margin-top: 3px;
}

.pcc-options {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}


/* =========================================================
   RADIOS
   ========================================================= */

.pcc-radio-option {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    min-height: 35px;
    margin: 0;
    border: 1px solid #dce3ec;
    border-radius: 7px;
    background: #fff;
    color: #556174;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    transition: all .18s ease;
    user-select: none;
}

.pcc-radio-option:hover {
    border-color: #337fd9;
    background: #f4f8fd;
    color: #337fd9;
}

.pcc-radio-option input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.pcc-radio-custom {
    width: 15px;
    height: 15px;
    border: 2px solid #b8c2d0;
    border-radius: 50%;
    position: relative;
    transition: all .18s ease;
}

.pcc-radio-option input:checked+.pcc-radio-custom {
    border-color: #337fd9;
    background: #337fd9;
}

.pcc-radio-option input:checked+.pcc-radio-custom:after {
    content: "";
    position: absolute;
    width: 5px;
    height: 5px;
    background: #fff;
    border-radius: 50%;
    left: 3px;
    top: 3px;
}

.pcc-radio-option:has(input:checked) {
    border-color: #337fd9;
    background: #eef5fd;
    color: #2563a9;
}


/* NO CUMPLE */

.pcc-option-danger:hover {
    border-color: #dc3545;
    background: #fff5f6;
    color: #c82333;
}

.pcc-option-danger input:checked+.pcc-radio-custom {
    border-color: #dc3545;
    background: #dc3545;
}

.pcc-option-danger input:checked+.pcc-radio-custom:after {
    background: white;
}


/* =========================================================
   ACCIÓN CORRECTIVA
   ========================================================= */

.pcc-corrective {
    flex: 1;
    min-width: 260px;
    max-width: 420px;
    padding: 9px;
    border: 1px solid #f2caca;
    border-radius: 8px;
    background: #fff7f7;
}

.pcc-corrective-header {
    color: #c82333;
    font-size: 10px;
    font-weight: 700;
    margin-bottom: 5px;
}

.pcc-corrective-header i {
    margin-right: 4px;
}

.pcc-accion-input {
    width: 100%;
    min-height: 42px;
    resize: vertical;
    border: 1px solid #e8c7ca;
    border-radius: 6px;
    font-size: 11px;
    box-shadow: none;
}

.pcc-accion-input:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 2px rgba(220, 53, 69, .08);
}


/* =========================================================
   OBSERVACIONES
   ========================================================= */

.pcc-observaciones-card {
    background: #fff;
    border: 1px solid #e3e8ef;
    border-radius: 11px;
    padding: 17px;
    margin-bottom: 20px;
    box-shadow: 0 3px 12px rgba(20, 42, 75, .04);
}

.pcc-observaciones-header {
    display: flex;
    align-items: center;
    gap: 11px;
    margin-bottom: 13px;
}

.pcc-observaciones-header h5 {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #24334d;
}

.pcc-observaciones-header span {
    display: block;
    margin-top: 2px;
    font-size: 10px;
    color: #8a95a6;
}

.pcc-observaciones-input {
    border: 1px solid #dce3ec;
    border-radius: 8px;
    font-size: 12px;
    resize: vertical;
    box-shadow: none;
}

.pcc-observaciones-input:focus {
    border-color: #337fd9;
    box-shadow: 0 0 0 3px rgba(51, 127, 217, .08);
}


/* =========================================================
   FIRMA
   ========================================================= */

.pcc-firma-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 16px 18px;
    border-radius: 11px;
    background: #fff;
    border: 1px solid #dce5f1;
    box-shadow: 0 3px 12px rgba(20, 42, 75, .04);
}

.pcc-firma-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.pcc-firma-icon {
    width: 44px;
    height: 44px;
    min-width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #eaf7f0;
    color: #20a464;
    font-size: 19px;
}

.pcc-firma-info h5 {
    margin: 0;
    color: #24334d;
    font-size: 14px;
    font-weight: 700;
}

.pcc-firma-info span {
    display: block;
    margin-top: 3px;
    color: #7b8798;
    font-size: 11px;
}

.pcc-firma-info strong {
    color: #24334d;
}

.btn-confirmar-firma {
    border: none;
    padding: 10px 17px;
    border-radius: 7px;
    background: #20a464;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: all .2s ease;
    white-space: nowrap;
}

.btn-confirmar-firma:hover {
    background: #188a53;
    transform: translateY(-1px);
}

.btn-confirmar-firma:disabled {
    opacity: .5;
    cursor: not-allowed;
    transform: none;
}

.btn-confirmar-firma i {
    margin-right: 5px;
}

.pcc-firmado-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 7px;
    background: #eaf7f0;
    color: #198754;
    font-size: 11px;
    font-weight: 700;
}


/* =========================================================
   RESPONSIVE
   ========================================================= */

@media (max-width: 992px) {

    .pcc-info-body {
        grid-template-columns: repeat(2, 1fr);
    }

    .pcc-question-card {
        align-items: flex-start;
        flex-direction: column;
        gap: 10px;
    }

    .pcc-question-title {
        width: 100%;
        min-width: auto;
    }

    .pcc-options {
        width: 100%;
    }

    .pcc-corrective {
        width: 100%;
        max-width: none;
    }
}


@media (max-width: 768px) {

    .pcc-modal-header {
        align-items: flex-start;
    }

    .pcc-header-actions {
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    .pcc-modal-body {
        padding: 12px;
    }

    .pcc-info-body {
        grid-template-columns: 1fr;
    }

    .pcc-firma-card {
        align-items: flex-start;
        flex-direction: column;
    }

    .btn-confirmar-firma {
        width: 100%;
    }

}


@media (max-width: 576px) {

    .pcc-header-content {
        align-items: flex-start;
    }

    .pcc-header-icon {
        display: none;
    }

    .pcc-header-actions .btn-guardar,
    .pcc-header-actions .btn-pdf {
        padding: 7px 9px;
        font-size: 11px;
    }

    .pcc-section-header {
        padding: 12px;
    }

    .pcc-question-card {
        padding: 13px;
    }

    .pcc-options {
        flex-direction: column;
        align-items: stretch;
    }

    .pcc-radio-option {
        width: 100%;
    }

}

.limite-critico-info {
    width: 100%;
    padding: 10px 12px;
    margin-bottom: 10px;

    background-color: #ffffff;
    border: 1px solid #e1e5eb;
    border-radius: 4px;

    color: #263b5b;
    font-size: 13px;
}

.limite-critico-titulo {
    margin-bottom: 6px;

    font-size: 14px;
    font-weight: 700;
    color: #263b5b;
    text-transform: uppercase;
}

.limite-critico-subtitulo {
    margin-bottom: 8px;

    font-size: 13px;
    font-weight: 600;
    color: #c94048;
    text-transform: uppercase;
}

.limite-critico-lista {
    display: flex;
    flex-direction: column;
    gap: 6px;

    font-size: 13px;
    font-weight: 400;
    color: #35465f;
}

.limite-critico-lista div {
    line-height: 1.2;
}
</style>
